//// rishab code for state and country
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./CustomerProfile.scss";
import CancelSaveHeader from "../../components/customPageHeader/CancelSaveHeader";
import { useAuth } from "../../contexts/auth";
import defaultProfilePic from "../../assets/profilepic.jpg";
import "../../components/typographyText/styles.scss";
import CustomTextBox from "../../components/customTextBox/CustomTextBox";
import CustomChangePwdPopup from "../../components/customPopup/CustomChangePwdPopup";
import { LoadPanel, SelectBox, TextBox } from "devextreme-react";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { generateOtpWithAction } from "../../api/forgotPwdApi";
import {
  editCustApi,
  getCountryState,
  getCustomerByCodeApi,
  requestAddressFromPin,
} from "../../api/companyCustomerApi";
import { useNavigate } from "react-router-dom";

export default function CustomerProfile() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [isProflePopupVisible, setisProflePopupVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [image, setImage] = useState();
  const [dispimage, setDispImage] = useState();
  const [loading, setLoading] = useState(false);
  const [cmpCustomerData, setCmpCustomerData] = useState();
  const custCountryRef = useRef();
  const [pinCodeRect, setPinCodeRect] = useState(true);

  const location = useLocation();
  const projectSectionRef = useRef(null);

  const [formData, setFormData] = useState({
    registeredAddress: "",
    city: "",
    pinCode: "",
    contactNumber: "",
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoading(true);
        const response = await getCountryState();
        const countriesList = response.data.map((country) => ({
          text: country.name,
          value: country.name,
          states: country.states, // Include states for later use
        }));
        setCountries(countriesList);
      } catch (error) {
        ToastDisplayer("error", error?.response?.data?.msg);
      } finally {
        setLoading(false);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states based on the selected country
  useEffect(() => {
    if (selectedCountry) {
      const countryData = countries.find(
        (country) => country.value === selectedCountry,
      );
      if (countryData) {
        const stateList = countryData.states.map((state) => ({
          text: state.name,
          value: state.name,
        }));
        setStates(stateList);
      }
    }
  }, [countries, selectedCountry]);

  useEffect(() => {
    const fetchCustomer = async () => {
      if (user) {
        try {
          setLoading(true);
          const result = await getCustomerByCodeApi(user?.custcode);
          if (result.status === 200 ) {
            setFormData({
              registeredAddress: result.data.data.custregaddr || "",
              city: result.data.data.custcity || "",
              pinCode: result.data.data.custpincode || "",
              contactNumber: result.data.data.custphno || "",
              state: result.data.data.custstate || "",
              country: result.data.data.custcountry || "",
            });
            custCountryRef.current = result.data.data.custcountry;
            setCmpCustomerData(result.data.data);
          }
        } catch (error) {
          ToastDisplayer(
            "error",
            error.response?.data?.error || "An unexpected error occurred.",
          );
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCustomer();
  }, []);

  useEffect(() => {
    if (location.state?.section === "projects") {
      setTimeout(() => {
        // Scroll to section
        projectSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        // 👇 ADD HIGHLIGHT HERE
        projectSectionRef.current?.classList.add("highlight");

        // Optional: remove highlight after few seconds
        setTimeout(() => {
          projectSectionRef.current?.classList.remove("highlight");
        }, 2000);
      }, 300);
    }
  }, [location.state]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.contactNumber) {
      newErrors.contactNumber = "Contact number is required.";
    } else if (!/^\d{3,15}$/.test(formData.contactNumber)) {
      newErrors.contactNumber =
        "Contact number must be numeric and must be between 3 to 15";
    }

    if (!formData.registeredAddress)
      newErrors.registeredAddress = "Address is required.";

    if (!formData.city) newErrors.city = "City is required.";

    if (!formData.pinCode) {
      newErrors.pinCode = "Pin code is required.";
    } else if (!/^\d{6}$/.test(formData.pinCode)) {
      newErrors.pinCode = "Pin code must be 6 digits.";
    } else if (!pinCodeRect)
      newErrors.pinCode = "Please enter a valid pincode!";

    if (!formData.country) newErrors.country = "Country is required.";

    if (!formData.state) newErrors.state = "State is required.";

    setErrors(newErrors);
    Object.values(newErrors).forEach((error) => {
      ToastDisplayer("error", error);
    });
    return Object.keys(newErrors).length === 0;
  };

  const handleImageClick = (e) => {
    e.preventDefault();
    document.getElementById("profileImage").click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    // setDispImage(file);
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        setImage(reader.result);
        setDispImage(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleImageHover = (isHovering) => {
    setIsHovered(isHovering);
  };

  const handleInputChange = (name) => (e) => {
    const value = e.value;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleProfileSaveDetails = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      var myformdata;

      if (dispimage !== undefined) {
        myformdata = {
          custregaddr: formData.registeredAddress,
          custcity: formData.city,
          custpincode: formData.pinCode,
          custphno: formData.contactNumber,
          custcountry:
            selectedCountry != null ? selectedCountry : formData.country,
          custstate: selectedState != null ? selectedState : formData.state,
          custlogo: dispimage,
        };
      } else {
        myformdata = {
          custregaddr: formData.registeredAddress,
          custcity: formData.city,
          custpincode: formData.pinCode,
          custphno: formData.contactNumber,
          custcountry:
            selectedCountry != null ? selectedCountry : formData.country,
          custstate: selectedState != null ? selectedState : formData.state,
        };
      }

      const result = await editCustApi(cmpCustomerData.custcode, myformdata);

      if (result.status === 200) {
        if (dispimage !== undefined) {
          setUser((prevUser) => ({
            ...prevUser,
            custlogo: dispimage,
          }));
          const getSess = JSON.parse(sessionStorage.getItem("authState")) || {};
          const updSess = { ...getSess, custlogo: dispimage };
          sessionStorage.setItem("authState", JSON.stringify(updSess));
        }

        ToastDisplayer("success", result.data.message);
        // navigate("/");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response ? error.response.statusText : error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileOtpPopup = async () => {
    try {
      setLoading(true);

      const otpResult = await generateOtpWithAction(user.email, "R");
      ToastDisplayer(
        otpResult?.status === 200 ? "success" : "error",
        otpResult?.status === 200
          ? otpResult.data.message
          : "OTP generation failed",
      );

      setisProflePopupVisible(!isProflePopupVisible);
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileCloseFromPopup = async () => {
    setisProflePopupVisible(!isProflePopupVisible);
  };

  //// trying to display customer logo
  useEffect(() => {
    if (user?.custlogo) {
      setImage(`data:image/jpeg;base64,${user?.custlogo}`);
    } else {
      setImage("");
    }
  }, [user]);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleGetAddress = async (pinCode) => {
    setLoading(true);
    if (pinCode.length === 6) {
      const getAddress = await requestAddressFromPin(pinCode);
      if (getAddress[0].Status === "Success") {
        setPinCodeRect(true);
        const add = getAddress[0].PostOffice[0];
        setFormData((prev) => {
          return {
            ...prev,
            country: add.Country,
            state: add.State,
            city: add.District,
          };
        });
      } else {
        setPinCodeRect(false);
      }
    }
    setLoading(false);
  };

  const handleSelectBoxChange = (field) => {
    return (e) => {
      const newValue = e.value;
      setFormData((prev) => {
        return {
          ...prev,
          [field]: newValue,
        };
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: undefined,
      }));
    };
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getStatusBadge = (endDate) => {
    if (!endDate) return { label: "Unknown", color: "unknown" };
    const diff = Math.ceil(
      (new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24),
    );
    if (diff < 0) return { label: "Expired", color: "expired" };
    if (diff <= 15) return { label: `Expires in ${diff}d`, color: "warning" };
    return {
      label: `Expires in ${diff} day${diff > 1 ? "s" : ""}`,
      color: diff <= 15 ? "warning" : "active",
    };
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="ProfilePage">
        <CancelSaveHeader
          titleName={"Client Profile"}
          handleDetCancel={handleCancel}
          handleDetSave={handleProfileSaveDetails}
        />

        <div className="profileMain">
          <div className="mainProfileSection">
            <div className="profileUpper">
              <div className="profileContent">
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div
                    className={`user-image-container ${isHovered ? "hovered" : ""}`}
                    onMouseEnter={() => handleImageHover(true)}
                    onMouseLeave={() => handleImageHover(false)}
                  >
                    <label htmlFor="profileImage">
                      <img src={image || defaultProfilePic} alt="Profile" />
                    </label>
                    {isHovered && (
                      <div className="hover-icon" onClick={handleImageClick}>
                        <i className="ri-user-add-line"></i>
                      </div>
                    )}
                    <input
                      type="file"
                      id="profileImage"
                      accept="image/*"
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 6 }}
                  >
                    <div className="typ-header-text">
                      {user?.login_name ||
                        user?.email?.split("@")[0] ||
                        "Username"}
                    </div>
                    <div className="typ-sub-text">
                      <span style={{ fontWeight: 600 }}>Email ID </span>:{" "}
                      {user?.email}
                    </div>
                    <div
                      className="custom-profile-text"
                      onClick={toggleProfileOtpPopup}
                    >
                      Change Password
                    </div>
                  </div>
                </div>
              </div>
              <div className="profileContent" style={{ marginTop: 14 }}>
                <div className="typ-sub-text">
                  <span style={{ fontWeight: 600 }}>Client Code</span> :{" "}
                  {cmpCustomerData?.custcode}
                </div>
              </div>
              <div className="profileContent" style={{ marginTop: 14 }}>
                <div className="typ-sub-text">
                  <span style={{ fontWeight: 600 }}>GST Number</span> :
                  {cmpCustomerData?.custgstno}
                </div>
              </div>
            </div>
            {/* <div className="profileFields"> */}
            {/* <div className="fieldsMain">
                <div className="detail-small-light">
                  Customer Name <span className="required">*</span>
                </div>
                <div className="detail-mid-light">
                  {cmpCustomerData?.custname}
                </div>
              </div> */}
            {/* <div className="fieldsMain">
                <div className="detail-small-light">
                  Email Address <span className="required">*</span>
                </div>
                <div className="detail-mid-light">
                  {cmpCustomerData?.custemail}
                </div>
              </div> */}
            {/* <div className="fieldsMain">
                <div className="detail-small-light">
                  Contact Number <span className="required">*</span>
                </div>
                <div className="detail-mid-light">
                  {cmpCustomerData?.custphno}
                </div>
              </div> */}
            {/* <div className="fieldsMain">
                <div className="detail-small-light">
                  Type <span className="required">*</span>
                </div>
                <div className="detail-mid-light">
                  {cmpCustomerData?.custtype}
                </div>
              </div> */}
            {/* </div> */}
          </div>
          <div className="editProfileSection">
            <div className="lowerSecProfile">
              <CustomTextBox
                label="Registered Address"
                placeholder="Registered Address"
                value={formData.registeredAddress}
                onChange={handleInputChange("registeredAddress")}
                type="text"
              />

              <CustomTextBox
                label="Contact Number"
                placeholder="Contact Number"
                value={formData.contactNumber}
                onChange={handleInputChange("contactNumber")}
                type="text"
              />
              {/* <CustomTextBox
                label="Pin Code"
                placeholder="Pin Code"
                value={formData.pinCode}
                onChange={handleInputChange("pinCode")}
                type="text"
              /> */}
              <div className="MyTextBox">
                <label className="TextBoxLabel">
                  Pin Code <span className="requiredClass">*</span>
                </label>
                <div className="TextBoxWrapper">
                  <TextBox
                    stylingMode="outlined"
                    className="TextBoxMain"
                    value={formData?.pinCode}
                    onValueChange={handleGetAddress}
                    onValueChanged={handleInputChange("pinCode")}
                    placeholder="Enter Pin Code"
                  />
                </div>
              </div>

              <CustomTextBox
                label="City"
                placeholder="City"
                value={formData.city}
                onChange={handleInputChange("city")}
                type="text"
              />

              <CustomTextBox
                label="State"
                placeholder="State"
                value={formData.state}
                onChange={handleInputChange("state")}
                type="text"
              />

              <CustomTextBox
                label="Country"
                placeholder="Country"
                value={formData.country}
                onChange={handleInputChange("country")}
                type="text"
              />

              {/* <div className="MyDropDown">
                <label className="ddLabel">
                  Country
                  <span className="requiredClass">*</span>
                </label>
                <div className="ddWrapper">
                  <SelectBox
                    className="ddMain"
                    stylingMode="outlined"
                    placeholder="Select Country"
                    items={countries}
                    value={formData?.country}
                    displayExpr="value"
                    onValueChanged={handleSelectBoxChange("country")}
                    // onValueChanged={handleInputChange("country")}
                    valueExpr="value"
                  />
                </div>
              </div> */}

              {/* <CustomDropdown
                label="Country"
                placeholder={formData.country}
                myDataSource={countries}
                setSelectedValue={handleInputChange("country")}
              />
 
              <CustomDropdown
                label="State"
                placeholder={
                  formData.state === "" ? "Select State" : formData.state
                }
                myDataSource={states}
                setSelectedValue={handleInputChange("state")}
              /> */}
            </div>
          </div>
          {/* <div className="projectSection" ref={projectSectionRef}>
            <div className="detail-small-light">
              Assigned Projects <span className="required">*</span>
            </div>
            <div className="lowerSecProfile">
              {cmpCustomerData?.assigned_projects?.length > 0 ? (
                cmpCustomerData.assigned_projects.map((category, index) => (
                  <div key={index} className="categoryBlock">
                    <div className="categoryTitle">
                      {category.category_name}
                    </div>

                    <div className="subcategoryList">
                      {category.subcategories.map((sub, subIndex) => (
                        <div key={subIndex} className="subcategoryItem">
                          • {sub.ticketsubcatname}
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="detail-mid-light">No Projects Assigned</div>
              )}
            </div>
          </div> */}
          <div className="projectSection" ref={projectSectionRef}>
            <div className="project-section-header">
              <i className="ri-folders-line"></i>
              <span>Assigned Projects</span>
            </div>

            <div className="lowerSecProfile">
              {cmpCustomerData?.assigned_projects?.length > 0 ? (
                cmpCustomerData.assigned_projects.map((category, index) => (
                  <div key={index} className="categoryBlock">
                    <div className="categoryTitle">
                      <i className="ri-stack-line"></i>
                      {category.category_name}
                      <span className="cat-count">
                        {category.subcategories.length} project
                        {category.subcategories.length !== 1 ? "s" : ""}
                      </span>
                    </div>

                    <div className="subcategoryList">
                      {category.subcategories.map((sub, subIndex) => {
                        const dates = {
                          start: sub.access_start,
                          end: sub.access_deadline,
                        };

                        const status = getStatusBadge(dates?.end);
                        return (
                          <div key={subIndex} className="subcategoryItem">
                            <div className="subcat-left">
                              <span className="subcat-dot" />
                              <span className="subcat-name">
                                {sub.ticketsubcatname}
                              </span>
                            </div>
                            <div className="subcat-right">
                              <div className="date-chip">
                                <i className="ri-play-circle-line" />
                                <span className="date-label">Start</span>
                                <span className="date-value">
                                  {formatDate(dates?.start)}
                                </span>
                              </div>
                              <div className="date-chip">
                                <i className="ri-stop-circle-line" />
                                <span className="date-label">End</span>
                                <span className="date-value">
                                  {formatDate(dates?.end)}
                                </span>
                              </div>
                              <div
                                className="expiryBadge"
                                style={{ width: 100 }}
                              >
                                <span
                                  className={`status-badge ${status.color}`}
                                  style={{ width: "auto" }}
                                >
                                  {status.label}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-projects">
                  <i className="ri-folder-forbid-line"></i>
                  <span>No Projects Assigned</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomChangePwdPopup
        visible={isProflePopupVisible}
        loading={loading}
        setLoading={setLoading}
        onClose={toggleProfileCloseFromPopup}
      />
    </>
  );
}
